import { useMutation } from '@tanstack/react-query';

import supabase from '../../../sdk/api';

const getData = async (query: string) => {
  const { data: userData } = await supabase.auth.getSession();

  try {
    await supabase
      .from('user_recent_queries')
      .delete()
      .eq('user_id', userData.session?.user.id)
      .eq('query', query);

    return userData.session?.user.id;
  } catch (error) {
    return error;
  }
};
export default function useDeleteRecentQuery() {
  return useMutation((query: string) => getData(query), {
    onSuccess: async (data) => data,
  });
}
